import React, { Fragment, useEffect, useState } from "react";
import TableForm from "./tableForm";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import logo from "./logo/udes.png";
import { formatDistanceWithOptions } from "date-fns/fp";

const FormApp2 = ({ reqID, empId, approveEvent }) => {
  const [requestData, setRequestData] = useState([]);
  const [itemsTableData, setItemsTableData] = useState([]);

  const handleRequestSelect = async (reqId) => {
    // get document data

    // get items table

    if (reqId !== null) {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/requests/` + reqId
      );
      const data = await response.json();

      setItemsTableData(
        data.itemsTableData.sort((a, b) => a.item_num - b.item_num)
      );
      setRequestData(data.requestData);

      if (requestData.approvedBy1) {
        setApprovedBy1("Approuvé");
      } else {
        setApprovedBy1("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy2("Approuvé");
      } else {
        setApprovedBy2("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy3("Approuvé");
      } else {
        setApprovedBy3("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy4("Approuvé");
      } else {
        setApprovedBy4("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy5("Approuvé");
      } else {
        setApprovedBy5("Non-apprové");
      }
    }
  };

  const updateReqStatus = async (reqId) => {
    if (reqId !== null) {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/requests/` + reqId
      );
      const data = await response.json();

      setItemsTableData(
        data.itemsTableData.sort((a, b) => a.item_num - b.item_num)
      );
      setRequestData(data.requestData);
    }
  };

  const [docs, setDocs] = useState([]);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/documents`
    );
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
  };

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  // get requests approval records --------------------------------

  const [approvalRecords, setApprovalRecords] = useState([]);
  const fetchApprovalRecords = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approval_records`
    );
    const data = await response.json();
    setApprovalRecords(data);
  };

  const [str, setStr] = useState([]);
  // fetch the list of structures from the database, the data includes str_id, str_name, str_parent, str_head
  const fetchStr = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/structures`
    );
    const data = await response.json();

    setStr(data);
  };

  const [emps, setEmps] = useState([]);
  const fetchEmp = async () => {
    // Fetch the forms and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/employees`
    );
    const data = await response.json();

    setEmps(data);
    // console.log(data[1].emp_role);
  };

  // get the current user role -----------------------------------------------------------------------

  const [currentRole, setCurrentRole] = useState("");
  async function getCurrentRole() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setCurrentRole(parsRes.emp_role);
    } catch (err) {
      console.error(err.message);
    }
  }
  // -------------------------------------------------------------------------------------------------

  //display the approval status of the document ------------------

  const [approvalRecordsCurrentReq, setApprovalRecordsCurrentReq] = useState(
    []
  );

  const getRecsCurrentReq = () => {
    let recordsList = [];
    for (let i = 0; i < approvalRecords.length; i++) {
      if (approvalRecords[i].req_id === reqID) {
        recordsList.push(approvalRecords[i]);
      }
    }
    setApprovalRecordsCurrentReq(recordsList);
  };

  // console.log(approvalRecordsCurrentReq);
  //---------------------------------------------------------------

  const displayApproverTitle = (appId) => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].app_id == appId) {
        return approvers[i].app_title;
      }
    }
  };

  const getTitlesList = () => {
    let titlesList = [];
    for (let i = 0; i < docs.length; i++) {
      if (docs[i].doc_type_id === requestData.doc_type) {
        titlesList.push(
          displayApproverTitle(requestData.appro_1),
          displayApproverTitle(requestData.appro_2),
          displayApproverTitle(requestData.appro_3),
          displayApproverTitle(requestData.appro_4),
          displayApproverTitle(requestData.appro_5),
          displayApproverTitle(requestData.appro_6),
          displayApproverTitle(requestData.appro_7),
          displayApproverTitle(requestData.appro_8)
        );
      }
    }
    return titlesList.filter((titles) => titles != null);
  };

  const [reqIsApproved, setReqIsApproved] = useState(true);

  const getReqApprovalStatus = () => {
    if (requestData.declined === true) {
      setReqIsApproved(false);
    } else {
      setReqIsApproved(true);
    }
  };

  useEffect(() => {
    getReqApprovalStatus();
  }, [requestData.declined]);
  const approversTitlesList = getTitlesList();

  function ApproDisplay({ approversTitlesList, reqAppRecList }) {
    const numberOfTitles = approversTitlesList.length;

    const layoutClass =
      numberOfTitles <= 1
        ? "appro-disp-single"
        : numberOfTitles === 2
        ? "appro-disp-double"
        : "appro-disp-multiple";

    return (
      <div className={layoutClass}>
        {approversTitlesList.map((title, index) => {
          const filteredRec = reqAppRecList.find(
            (record) => record.app_title === title
          );
          const approverName = filteredRec?.emp_name;

          return (
            <div key={index} className={`appro-disp-${index + 1}`}>
              <p className="appro-title">{title}</p>
              {reqIsApproved && approverName && (
                <p className="appro-name">Approuvé par Mr. {approverName}</p>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  const isCSMG = () => {
    let CSMG = false;

    if (currentRole === 25) {
      CSMG = true;
    } else {
      CSMG = false;
    }

    return CSMG;
  };

  const [availabilityChecks, setAvailabilityChecks] = useState({});

  // Initialize the availabilityChecks state with the availability values from itemsTableData
  useEffect(() => {
    const initialAvailabilityChecks = {};
    itemsTableData.forEach((item) => {
      initialAvailabilityChecks[item.item_num] = item.availability;
    });
    setAvailabilityChecks(initialAvailabilityChecks);
  }, [itemsTableData]);

  const handleAvailabilityChange = async (item_num, checked) => {
    // Update the local state first
    setAvailabilityChecks((prevChecks) => ({
      ...prevChecks,
      [item_num]: checked,
    }));

    // Prepare the data to be sent to the backend
    const requestData = {
      reqIdToUpdate: reqID,
      itemNum: item_num,
      updatedData: checked,
    };

    try {
      // Send the update request to the backend
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/changeItemAvailabilityState`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      // Handle the response from the backend
      if (response.ok) {
        console.log("Availability state updated successfully");
      } else {
        console.error("Failed to update availability state");
      }
    } catch (error) {
      // Handle any errors that occurred during the fetch
      console.error("Error sending update request:", error);
    }
  };

  function Table({ itemsTableData }) {
    return (
      <table className="doc-table table">
        <thead className="table-head">
          <tr>
            <th className="align-top">N°</th>
            <th className="align-top">
              Désignation des fournitures ou travaux
            </th>
            <th className="align-top">Quantité</th>
            {isCSMG() ? (
              <th className="obsrv">
                Observation (D: Disponible, ND: Non-Disponible)
              </th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          {itemsTableData.map((request) => (
            <tr key={request.item_num}>
              <td>{request.item_num}</td>
              <td>{request.item_description}</td>
              <td>{request.item_qt}</td>
              {isCSMG() ? (
                <td>
                  <label>
                    Disponible
                    <input
                      type="checkbox"
                      checked={availabilityChecks[request.item_num]}
                      onChange={(e) =>
                        handleAvailabilityChange(
                          request.item_num,
                          e.target.checked
                        )
                      }
                    />
                  </label>
                </td>
              ) : (
                ""
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  const displayStructure = (str_id) => {
    let str_name = "";
    for (let i = 0; i < str.length; i++) {
      // check if str_id == str[i].str_id and return str[i].str_name
      if (str[i].str_id === str_id) {
        str_name = str[i].str_name;
      }
    }
    return str_name;
  };

  const displayRequesterName = (emp_id) => {
    for (let i = 0; i < emps.length; i++) {
      if (emps[i].emp_id == emp_id) {
        return emps[i].emp_name;
      }
    }
  };

  useEffect(() => {
    fetchApprovalRecords();
    getRecsCurrentReq();
    getReqApprovalStatus();
  }, [approvalRecords.length, reqID, approveEvent]);

  useEffect(() => {
    updateReqStatus(reqID);
  }, [approveEvent, reqID]);

  useEffect(() => {
    fetchStr();
    fetchEmp();
    handleRequestSelect(reqID);
    fetchDocs();
    fetchAppro();
    getCurrentRole();
  }, []);

  useEffect(() => {
    handleRequestSelect(reqID);
  }, [reqID]);

  const [approvedBy1, setApprovedBy1] = useState(null);
  const [approvedBy2, setApprovedBy2] = useState(null);
  const [approvedBy3, setApprovedBy3] = useState(null);
  const [approvedBy4, setApprovedBy4] = useState(null);
  const [approvedBy5, setApprovedBy5] = useState(null);

  return (
    <div className="document-page">
      <div className="doc-heading">
        <div className="doc-heading-top">
          <div className="doc-ht-ar">
            الجمهورية الجزائرية الديمقراطية الشعبية
          </div>
          <div className="doc-ht-fr">
            République Algérienne Démocratique et Populaire
          </div>
          <div className="doc-ht-ar">وزارة التعليم العالي و البحث العلمي</div>
          <div className="doc-ht-fr">
            Ministère de l'Enseignement Supérieur et de la Recherche
            Scientifique
          </div>
        </div>
        <div className="doc-heading-line"></div>
        <div className="doc-heading-bottom">
          <div className="doc-hb-left">
            <span className="doc-hb-uplef-text">EPST/CDER</span>
            <span className="doc-hb-bottlef-text">
              UNITE DE DEVELOPEMENT DES EQUIPEMENTS SOLAIRES
            </span>
          </div>
          <div className="doc-heading-logo">
            <img src={logo} alt="logo" />
          </div>

          <div className="doc-hb-right">
            <span className="doc-hb-upright-text">م.ع.ط.ع.ت./م.ط.ت.م</span>
            <span className="doc-hb-bottright-text">
              وحدة تنمية الاجهزة الشمسية
            </span>
          </div>
        </div>
        <div className="doc-heading-line"></div>
      </div>

      <div className="doc-body-top">
        <div className="doc-top-info">
          <span className="label">N°:</span>
          <span className="value">{requestData.ref_field}</span>
        </div>
        <div className="doc-top-info">
          <span className="label">Bou-ismail, le:</span>
          <span className="value">
            {new Date(requestData.req_date).toLocaleDateString("en-GB")}
          </span>
        </div>
      </div>

      <div className="doc-body-middle">
        <div className="doc-body-title">
          <h5>DEMANDE D'APPROVISIONNEMENT HORS PROJET DE RECHERCHE</h5>
        </div>
        <div className="doc-body-mid-info">
          <div className="info">
            <span className="">Equipe/Division/Atelier/Service:</span>
            <span className="value">
              {displayStructure(requestData.issuing_str)}
            </span>
          </div>

          <div className="info">
            <span className="">Demandeur:</span>
            <span className="value">
              {displayRequesterName(requestData.requester_id)}
            </span>
          </div>
        </div>

        <Table itemsTableData={itemsTableData} />

        {/* <table className='doc-table table '>
          <thead className='table-head'>
            <tr>
              <th className='align-top'>N°</th>
              <th className='align-top'>
                Désignation des fournitures ou travaux
              </th>
              <th className='align-top'>Quantité</th>
              <th className='obsrv'>
                Observation (D: Disponible, ND: Non-Disponible)
              </th>
            </tr>
          </thead>
          <tbody>
            {itemsTableData.map((request) => (
              <tr key={request.req_id}>
                <td>{request.item_num}</td>
                <td>{request.item_description}</td>

                <td>{request.item_qt}</td>
                <td>{request.item_observation}</td>
              </tr>
            ))}
          </tbody>
        </table> */}
      </div>

      <div className="doc-body-bottom">
        <div id="doc-approvers" className="doc-approvers">
          <ApproDisplay
            approversTitlesList={approversTitlesList}
            reqAppRecList={approvalRecordsCurrentReq}
          />
          {/* <span id="approver5">{approvedBy5}</span> */}
        </div>
      </div>

      <div className="doc-footer">
        <div className="doc-footer-separator"></div>
        <span className="doc-footer-text">
          UDES, Route Nationale N°11, BP386, Bou-Ismail, 42415, Wilaya de Tipaza
          Tel. / Fax : 024221408, Site Web :udes.cder.dz
        </span>
      </div>
    </div>
  );
};

export default FormApp2;
